<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Problems -->
                    <div class="col-12">
                        <transition
                                name="fade"
                                mode="out-in"
                        >
                            <div v-if="!currentlySelectedProblem">
                                <!-- Title -->
                                <div class="col-12">
                                    <div class="title">
                                        <h1>What needs repairing?</h1>
                                    </div>
                                </div>
                                <div class="alert alert-info" v-if="inWarrantyStatus && restrictedProblems.length">
                                    <div class="alert-content">
                                        Items marked with a <i class="fa fa-ban text-danger"></i> are not covered under your warranty
                                    </div>
                                </div>
                                <div class="card-list repair-list scrollable">
                                    <div class="selectable-card"
                                         v-for="problem in filterOutHiddenProblems"
                                         :key="problem.id"
                                         @click="selectProblem(problem)"
                                         :class="{ active: problemIsSelected(problem) || batteryIsIncluded(problem), 'disabled no-transition': batteryIsIncluded(problem), 'restricted': problemIsRestricted(problem) }">
                                        <div class="card-body">
                                            <p v-html="problemTitle(problem)"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <!-- Symptom List -->
                        <transition
                                name="fade"
                                mode="out-in"
                        >
                            <div v-if="currentlySelectedProblem">
                                <!-- Title -->
                                <div class="col-12">
                                    <div class="title">
                                        <h1>What's wrong with the {{ currentlySelectedProblem.title }}?</h1>
                                    </div>
                                    <label>
                                        Select all that apply
                                    </label>
                                </div>
                                <div class="card-list">
                                    <div class="selectable-card"
                                         v-for="symptom in currentlySelectedProblem.symptoms"
                                         :key="symptom.id"
                                         @click="selectSymptom(symptom)"
                                         :class="{ active: symptomIsSelected(symptom) }">
                                        <div class="card-body">
                                            {{ symptom.title }}
                                        </div>
                                    </div>

                                    <div @click="addAnotherProblem()" class="card card-body flex-row align-items-center justify-content-center text-decoration-none cursor-pointer" :class="{ disabled: !selectionsHaveBeenSelected }">
                                        <i class="fa fa-plus mr-3"></i> <strong>Add another problem</strong>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <button class="btn btn-outline-secondary back-btn btn-lg" @click="back()"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</button>
                    <button @click="confirmSelections()" class="btn btn-lg continue-btn icon-right ml-auto" :class="{'disabled': !selectionsHaveBeenSelected}">{{ totalSelections }}<span class="text-lowercase">x</span> Selected <i class="fa fa-chevron-right ml-3 text-sm"></i></button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "SelectRepair",

        data() {
            return {
                currentlySelectedProblem: null,
                symptomSelected: false
            }
        },

        mounted() {
            this.checkCanBeOnPage();
            this.loadMakes();
        },

        computed: {
            ...mapGetters([
                'aProblemHasBeenSelected',
                'askBackGlass',
                'askFrame',
                'backGlassProblem',
                'displayUpsellOptions',
                'frameProblem',
                'inWarrantyStatus',
                'makeIsSamsung',
                'modelVersionHasBeenSelected',
                'problems',
                'restrictedProblems',
                'selectedModel',
                'selectedProblems',
                'upsellOptions'
            ]),

            previousStep() {
                if (this.allowsInsuranceOrder) return "deviceInsuranceStatus";

                return (this.makeIsSamsung && this.inWarrantyStatus) ? "deviceWarrantyStatus" : "deviceColour";
            },

            nextStep() {
                if (this.displayUpsellOptions) return 'extras';

                if (this.askBackGlass && this.backGlassProblem) return 'confirmDamage';
                if (this.askFrame && this.frameProblem) return 'confirmDamage';

                return 'basket';
            },

            /** Determine is screen repair has been selected */
            screenIsSelected() {
                for (let i = 0; i < this.selectedProblems.length; i++) {
                    if (this.selectedProblems[i].code === 'screen-replacement') {
                        return true;
                    }
                }
                return false;
            },

            selectionsHaveBeenSelected() {
                if (!this.currentlySelectedProblem) {
                    return this.selectedProblems.length > 0;
                }

                for (let i = 0; i < this.selectedProblems.length; i++) {
                    if (this.currentlySelectedProblem.id === this.selectedProblems[i].id) {
                        return this.selectedProblems[i].symptoms.length > 0;
                    }
                }
                return false;
            },

            /** Get number selected problems */
            totalSelections() {
                if (this.currentlySelectedProblem) {
                    // Display the total selected symptoms

                    for (let i = 0; i < this.selectedProblems.length; i++) {
                        if (this.currentlySelectedProblem.id === this.selectedProblems[i].id) {
                            return this.selectedProblems[i].symptoms.length;
                        }
                    }
                    return 0;
                }

                // Display the total selected problems
                let total = this.selectedProblems.length;

                if (this.selectedModel && this.selectedModel.battery_required_for_screen_repair && this.screenIsSelected && !this.inWarrantyStatus) {
                    total += 1;
                }

                return total;
            },

            filterOutHiddenProblems: function () {
              return this.problems.filter(i => i.hidden_from_frontend == 0)
            },
        },

        methods: {
            ...mapActions([
                'checkBookingIsComplete',
                'loadMakes',
                'toggleProblem',
                'toggleSymptom',
                'updateDevice'
            ]),

            addAnotherProblem() {
                if (!this.selectionsHaveBeenSelected) return;
                this.currentlySelectedProblem = null;
            },

            back() {
                if (this.currentlySelectedProblem) {
                    this.toggleProblem(this.currentlySelectedProblem);
                    this.currentlySelectedProblem = null;
                    return;
                }

                return this.$router.push({name: this.previousStep});
            },

            batteryIsIncluded(problem) {
                if (this.inWarrantyStatus || !this.selectedModel || !this.selectedModel.battery_required_for_screen_repair) {
                    return false;
                }
                return (this.screenIsSelected && problem.code === 'battery-replacement');
            },

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.modelVersionHasBeenSelected) {
                        this.$router.push({name: 'deviceColour'});
                    }
                });
            },

            confirmSelections() {
                this.updateDevice(true);

                this.$router.push({name: this.nextStep});
            },

            problemIsRestricted(problem) {
                if (!this.inWarrantyStatus || !this.restrictedProblems.length) {
                    return false;
                }
                return this.restrictedProblems.includes(problem.id);
            },

            problemIsSelected(problem) {
                for (let i = 0; i < this.selectedProblems.length; i++) {
                    if (this.selectedProblems[i].id === problem.id) {
                        return true;
                    }
                }
                return false;
            },

            problemTitle(problem) {
                if (this.inWarrantyStatus) {
                    return problem.title;
                }

                if (this.selectedModel && this.selectedModel.battery_required_for_screen_repair && problem.code ==='screen-replacement') {
                    return problem.title + "<span class='free-battery'> - (Includes FREE battery replacement)</span>";
                }

                if (this.batteryIsIncluded(problem) && problem.code ==='battery-replacement') {
                    return problem.title + "<span class='text-sm'> - (Included FREE with screen repair)</span>";
                }

                return problem.title;
            },

            selectProblem(problem) {
                if (this.problemIsRestricted(problem)) {
                    return;
                }

                this.toggleProblem(problem);

                // Enable this to reintroduce symptoms
                // if (this.problemIsSelected(problem)) {
                //     this.currentlySelectedProblem = problem;
                // }
            },

            selectSymptom(symptom) {
                this.toggleSymptom({problem: this.currentlySelectedProblem, symptom: symptom})
                    .catch(() => {
                        this.currentlySelectedProblem = null;
                    });
            },

            symptomIsSelected(symptom) {
                for (let i = 0; i < this.selectedProblems.length; i++) {
                    for (let j = 0; j < this.selectedProblems[i].symptoms.length; j++) {
                        if (this.selectedProblems[i].symptoms[j].id === symptom.id) {
                            return true;
                        }
                    }
                }
                return false;
            }
        }
    }
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }
	/* IE11 */
	@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
		.fade-enter-active,
		.fade-leave-active,
		.fade-enter {
			opacity: 1;
			transition: none;
		}
	}
</style>